export const getGtmUserType = () => {
  let gtmUserType = "NewUser"

  if (
    typeof localStorage !== "undefined" &&
    localStorage.getItem("recentSearches")
  ) {
    gtmUserType = "ReturnNonPersonalizedUser"
  }

  return gtmUserType
}

export const fireGtmEvent = obj => {
  if (typeof window !== "undefined") {
    window.gtmDataLayer = window.gtmDataLayer || []
    window.gtmDataLayer.push(obj)
  }
}